import React from 'react';
import { useStaticQuery, graphql } from 'gatsby'
import { Accordion, AccordionItem } from '@szhsin/react-accordion';

const FAQs = () => {
const faqsQuery = useStaticQuery(graphql`
    query {
      allBuilderModels {
        faQs (
          options: {
            cachebust: true
          }
        ) {
          id
          content
        }
      }
    }
  `);

  const list = faqsQuery?.allBuilderModels?.faQs;

  if (!list?.length) {
    return <></>;
  }

  const faqsList = list.map(({ id, content }) => {
    return {
      id,
      question: content.data.question,
      answer: content.data.answer,
    };
  });

  return (
    <div className='rs-faq pt-20 pb-20 md-pt-15 md-pb-15'>
      <div className='row y-middle'>
        <div className='col-lg-12 md-mb-50'>
            <div className='content-part'>
              <div className='faq-content'>
                <Accordion id='accordion' className='accordion'>
                  {faqsList.map(({ id, question, answer }) => (
                    <AccordionItem className='card' header={question} key={id}>
                      {answer}
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default FAQs;
